import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const productsApi = createApi({
    reducerPath: "productsApi",
    tagTypes: ["Products", "Builds", "Variables", "ChangeLogs"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        addProductVariable: rtkClient.addProductVariable(builder),
        cancelBuild: rtkClient.cancelBuild(builder),
        createBuild: rtkClient.createBuild(builder),
        createProduct: rtkClient.createProduct(builder),
        deleteBuild: rtkClient.deleteBuild(builder),
        deleteProduct: rtkClient.deleteProduct(builder),
        getQueuedBuilds: rtkClient.getQueuedBuilds(builder),
        deleteProductChangeLog: rtkClient.deleteProductChangeLog(builder),
        deleteProductVariable: rtkClient.deleteProductVariable(builder),
        fetchBuildsForProducts: rtkClient.fetchBuildsForProducts(builder),
        fetchProductBuilds: rtkClient.fetchProductBuilds(builder),
        fetchProductChangeLogs: rtkClient.fetchProductChangeLogs(builder),
        fetchProductById: rtkClient.fetchProductById(builder),
        fetchProducts: rtkClient.fetchProducts(builder),
        fetchProductVariables: rtkClient.fetchProductVariables(builder),
        fetchVisibleProducts: rtkClient.fetchVisibleProducts(builder),
        importProductBuild: rtkClient.importProductBuild(builder),
        updateBuildChannel: rtkClient.updateBuildChannel(builder),
        updateBuildMetadata: rtkClient.updateBuildMetadata(builder),
        updateBuildRollout: rtkClient.updateBuildRollout(builder),
        updateFileFullOtaCompatibility: rtkClient.updateFileFullOtaCompatibility(builder),
        updateProduct: rtkClient.updateProduct(builder),
        updateProductAndroidVersion: rtkClient.updateProductAndroidVersion(builder),
        updateProductChangeLog: rtkClient.updateProductChangeLog(builder),
        updateProductCodename: rtkClient.updateProductCodename(builder),
        updateProductVisibility: rtkClient.updateProductVisibility(builder),
    }),
});

export const {
    useAddProductVariableMutation,
    useCancelBuildMutation,
    useGetQueuedBuildsQuery,
    useCreateBuildMutation,
    useCreateProductMutation,
    useDeleteBuildMutation,
    useDeleteProductMutation,
    useDeleteProductChangeLogMutation,
    useDeleteProductVariableMutation,
    useFetchBuildsForProductsQuery,
    useFetchProductBuildsQuery,
    useFetchProductChangeLogsQuery,
    useFetchProductByIdQuery,
    useFetchProductsQuery,
    useFetchProductVariablesQuery,
    useFetchVisibleProductsQuery,
    useImportProductBuildMutation,
    useUpdateBuildChannelMutation,
    useUpdateBuildMetadataMutation,
    useUpdateBuildRolloutMutation,
    useUpdateFileFullOtaCompatibilityMutation,
    useUpdateProductMutation,
    useUpdateProductAndroidVersionMutation,
    useUpdateProductChangeLogMutation,
    useUpdateProductCodenameMutation,
    useUpdateProductVisibilityMutation,
    usePrefetch,
} = productsApi;
